export const CTA_BUTTONS = {
  CTA_DIVE_DEEPER: 'dive_deeper',
  CTA_FAVORITE: 'favorite',
  CTA_CREATE_ALERT: 'create_alert',
  CTA_SHARE: 'share',
  CTA_REPORT_ISSUE: 'report_issue',
  CTA_DOWNLOAD: 'download_data',
};
